import React from "react";
import { FaYoutube, FaLinkedinIn, FaArrowCircleUp, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { footerIcons } from "../styles/common.module.css";

export default function Footer() {
  // Scroll to top
  const scrollToTop = () => {
    window.scroll({ top: 0 });
  };
  const currentYear = new Date().getFullYear();
  
  const footerStyle = {
    backgroundColor: "#f8f9fa",
    padding: "25px 0",
    borderTop: "1px solid #e9ecef",
    width: "100vw",
    marginLeft: "calc(-50vw + 50%)",
    position: "relative"
  };

  const containerStyle = {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 40px"
  };

  const topRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "20px"
  };

  const contactSectionStyle = {
    display: "flex",
    gap: "60px",
    alignItems: "center",
    flexWrap: "wrap"
  };

  const contactItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "15px",
    color: "#2c3e50"
  };

  const iconStyle = {
    backgroundColor: "#2c3e50",
    color: "white",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    flexShrink: 0
  };

  const socialSectionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "15px"
  };

  const socialIconStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    textDecoration: "none",
    transition: "all 0.3s ease"
  };

  const copyrightStyle = {
    textAlign: "center",
    fontSize: "14px",
    color: "#6c757d",
    paddingTop: "15px",
    borderTop: "1px solid #e9ecef",
    width: "100vw",
    marginLeft: "calc(-50vw + 50%)",
    position: "relative"
  };

  const scrollButtonStyle = {
    ...iconStyle,
    backgroundColor: "#6c757d",
    cursor: "pointer",
    transition: "all 0.3s ease"
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <div style={topRowStyle}>
          <div style={contactSectionStyle}>
            <div style={contactItemStyle}>
              <div style={iconStyle}>
                <FaMapMarkerAlt />
              </div>
              <div>
                <div style={{ fontWeight: "500", fontSize: "15px" }}>565 Metro Pl S</div>
                <div style={{ fontSize: "15px" }}>Ste 300</div>
                <div style={{ fontSize: "15px" }}>Dublin, OH 43017</div>
              </div>
            </div>
            
            <div style={contactItemStyle}>
              <div style={iconStyle}>
                <FaPhone />
              </div>
              <div style={{ fontWeight: "500", fontSize: "15px" }}>
                (614) 726-1818
              </div>
            </div>
          </div>

          <div style={socialSectionStyle}>
            <a
              href="https://www.youtube.com/channel/UCO7cwgFkV4N5mN77d1TNeVQ"
              target="_blank"
              rel="noreferrer"
              style={{
                ...socialIconStyle,
                backgroundColor: "#FF0000",
                color: "white"
              }}
              title="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://in.linkedin.com/company/digital-biz-tech"
              target="_blank"
              rel="noreferrer"
              style={{
                ...socialIconStyle,
                backgroundColor: "#0077B5",
                color: "white"
              }}
              title="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <div
              onClick={scrollToTop}
              style={scrollButtonStyle}
              title="Scroll to Top"
            >
              <FaArrowCircleUp />
            </div>
          </div>
        </div>
      </div>
      
      <div style={copyrightStyle}>
        © {currentYear} Digital Biz Tech
      </div>
    </footer>
  );
}
